import { CorrectionEvidenceDownload } from '../sales/CorrectionEvidence';
import React from 'react';
import type { LotAuditLog } from '../../types/inventory';
import './PropertyCorrectionDetails.css';

const labels: Record<string, string> = { classification: 'Classification', propertyVariant: 'Property variant', tier: 'Tier', layer: 'Layer', areaSqm: 'Area (sqm)', lotTypeId: 'Lot type ID' };
export default function PropertyCorrectionDetails({ log }: { log: LotAuditLog }) {
  const metadata = log.metadata;
  if (!metadata || !Array.isArray(metadata.changes) || !metadata.changes.length) return <p>Field-level evidence was not recorded for this older entry.</p>;
  return <div className="lot-property-history">
    <p>Evidence reference: {metadata.evidenceReference || 'Not recorded'}</p>
    <CorrectionEvidenceDownload version={log.evidenceVersion} />
    <dl>{metadata.changes.map(change => <div key={change.field}><dt>{labels[change.field] || change.field}</dt><dd><span>Before: {change.before ?? 'Not recorded'}</span><span>After: {change.after ?? 'Not recorded'}</span></dd></div>)}</dl>
  </div>;
}
